import { SettingsOutlined } from '@material-ui/icons';
import React from 'react';

const SettingsIcon = ({ color }) => <SettingsOutlined style={{ color }} />;

export default SettingsIcon;
